/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./dco-table.vue?vue&type=template&id=a57ef9bc&"
import script from "./dco-table.vue?vue&type=script&lang=js&"
export * from "./dco-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports